// eslint-disable-next-line no-restricted-imports
import { type GridFooterCellProps } from "@progress/kendo-react-grid/dist/npm/interfaces/GridFooterCellProps";
import { memo, PureComponent } from "react";

import { cn } from "@btnet/utilities-core";

import { type GridColumn as BTGridColumn } from "commonComponents/utilities/Grid/GridContainer.types";
import { type ILineItemColumn } from "commonComponents/utilities/LineItemContainer/types/LineItem.interfaces";

export interface IFooterCellProps<TCellType = any> extends GridFooterCellProps {
    column: BTGridColumn<any, TCellType> | ILineItemColumn<any, any, TCellType>;
    value?: any;
    onCellClick?: () => void;
    contentOnly?: boolean; // if true, will render as a div instead of a td
    classname?: string;
    "data-testid"?: string;
}

const DefaultFooterCell = memo<IFooterCellProps>(function DefaultFooterCell({ value }) {
    return <>{value}</>;
});

export class BTGridFooterCell extends PureComponent<IFooterCellProps> {
    private handleCellClick = (e: React.MouseEvent) => {
        const { onCellClick } = this.props;
        if (onCellClick) {
            onCellClick();
        }
        e.stopPropagation();
    };

    render() {
        const { column, style, field, contentOnly, classname } = this.props;

        const FooterCell = column?.FooterCell ?? DefaultFooterCell;

        const Container = contentOnly ? "div" : "td";

        return (
            /* set background to undefined so we let BTGridFooterCell handle the background color */
            <Container
                className={cn("BTGridFooterCell", classname)}
                data-testid={`${field}--footer`}
                style={{ ...style, textAlign: column?.align, background: undefined }}
                onClick={this.handleCellClick}
            >
                <FooterCell {...this.props} />
            </Container>
        );
    }
}
